import React from 'react';
import localization from '../helpers/localization';
import { contentRoot } from '../config.js';



const ProductGroupSelectionPage = ({ hasBench, hasPaneling, hasStove, hasLights, hasDoor, toggleBench, toggleDoor, togglePaneling, toggleLights, toggleStove, nextPage, prevPage }) => (
    <div className="page">
        <div className={getStyle(hasBench)} onClick={() => { toggleBench() }} style={{ backgroundImage: "url(" + contentRoot + "img/laude.jpg)" }} role="button" aria-pressed={hasBench}>
            <div>{localization.benches}</div>
            {getBottomBar(hasBench)}
        </div>
        <div className={getStyle(hasDoor)} onClick={() => { toggleDoor() }} style={{ backgroundImage: "url(" + contentRoot + "img/ovitausta.jpg)" }} role="button" aria-pressed={hasDoor}>
            <div className="doorGroupTitle">{localization.doorProductGroup}</div>           
            {getBottomBar(hasDoor)}
        </div>
        <div className={getStyle(hasPaneling)} onClick={() => { togglePaneling() }} style={{ backgroundImage: "url(" + contentRoot + "img/paneelitausta.jpg)" }} role="button" aria-pressed={hasPaneling}>{localization.paneling}
            {getBottomBar(hasPaneling)}
        </div>
        <div className={getStyle(hasLights)} onClick={() => { toggleLights() }} style={{ backgroundImage: "url(" + contentRoot + "img/valotausta.jpg)" }} role="button" aria-pressed={hasLights}>{localization.ligthing}
            {getBottomBar(hasLights)}
        </div>
        <div className={getStyle(hasStove)} onClick={() => { toggleStove() }} style={{ backgroundImage: "url(" + contentRoot + "img/kiuastausta.jpg)" }} role="button" aria-pressed={hasStove}>{localization.stove}
            {getBottomBar(hasStove)}
        </div>
        <div className="changePhaseRow">
            <span className="orangeButton changePhaseButton" onClick={() => { prevPage() }}> <span className="buttonTxt">&#8592;  {localization.prevPhase}</span></span>
            <span className="orangeButton changePhaseButton" onClick={() => { nextPage() }}> <span className="buttonTxt"> {localization.nextPhase} &#8594;</span></span>
        </div>
    </div>
);
export default ProductGroupSelectionPage

let getStyle = (enabled) => "productGroupSelection " + (enabled ? "enabled" : "disabled");

let getBottomBar = (enabled) => {
    let className = enabled ? "bottomBarEnabled bottomBar" : "bottomBarDisabled bottomBar";
    let text = enabled ? localization.selected : "Lisää";
    return (<div className={className}><span className="productStatusIcon">{enabled ? "✓" : "+"}</span><span>{text}</span></div>);

}
